<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>睿世力购物</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入商品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="商品名称" width="300px"></el-table-column>
          <el-table-column prop="Price" label="商品金额" width="300px"></el-table-column>
          <el-table-column prop="Iconimage" label="商品图标" width="300px">
            <template slot-scope="scope">
              <img :src="scope.row.Iconimage" min-width="64" height="64" />
            </template>
          </el-table-column>
          <el-table-column label="商品上架状态" width="300px">
            <template slot-scope="scope">
              <span v-if="scope.row.Shelves === 1" style="color: #05bb74;">{{ scope.row.ShelvesName }}</span>
              <span v-if="scope.row.Shelves === 0" style="color: #e95d4e;">{{ scope.row.ShelvesName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Shelves == 0" @click="clickShangJia(scope.row)">上架</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Shelves == 1" @click="clickXiaJia(scope.row)">下架</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加商品 start -->
      <el-tab-pane label="添加商品" name="second">
        <el-form :model="addForm" ref="addFormRef" label-width="100px">
          <el-form-item label="商品名称" class="addAdminForm">
            <el-input v-model="addForm.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品价格" class="addAdminForm">
            <el-input v-model="addForm.price" placeholder="请输入商品价格"></el-input>
          </el-form-item>
          <el-form-item label="图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.iconimage" @change="addTencentyunCosUploadiconimage"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片1" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.introduceimage1" @change="addTencentyunCosUploadintroduceimage1"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片2" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.introduceimage2" @change="addTencentyunCosUploadintroduceimage2"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片3" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.introduceimage3" @change="addTencentyunCosUploadintroduceimage3"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加商品 end -->

      <!-- 编辑商品 start -->
      <el-tab-pane label="编辑商品" name="three" v-if="displaythree">
        <el-form :model="editForm" ref="editFormRef" label-width="100px">
          <el-form-item label="商品名称" class="addAdminForm">
            <el-input v-model="editForm.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品价格" class="addAdminForm">
            <el-input v-model="editForm.price" placeholder="请输入商品价格"></el-input>
          </el-form-item>
          <el-form-item label="图标" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.iconimage" @change="addTencentyunCosUploadiconimage"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片1" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.introduceimage1" @change="addTencentyunCosUploadintroduceimage1"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片2" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.introduceimage2" @change="addTencentyunCosUploadintroduceimage2"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="简介图片3" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="editForm.introduceimage3" @change="addTencentyunCosUploadintroduceimage3"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="postEdit">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 编辑商品 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg
  },
  name: 'MyMiniProgramRuiShiLiGouWuProducts',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        name: ''
      },
      // 添加
      addForm: {
        name: '',
        price: '',
        iconimage: '',
        introduceimage1: '',
        introduceimage2: '',
        introduceimage3: ''
      },
      editForm: {
        id: '',
        name: '',
        price: '',
        iconimage: '',
        introduceimage1: '',
        introduceimage2: '',
        introduceimage3: ''
      },
      displaythree: false
    }
  },
  mounted () {
    this.apiRuiShiLiGouWuProductsGetNum()
    this.apiRuiShiLiGouWuProductsGetList()
  },
  methods: {
    addTencentyunCosUploadiconimage (url) {
      this.addForm.iconimage = url
      this.editForm.iconimage = url
    },
    addTencentyunCosUploadintroduceimage1 (url) {
      this.addForm.introduceimage1 = url
      this.editForm.introduceimage1 = url
    },
    addTencentyunCosUploadintroduceimage2 (url) {
      this.addForm.introduceimage2 = url
      this.editForm.introduceimage2 = url
    },
    addTencentyunCosUploadintroduceimage3 (url) {
      this.addForm.introduceimage3 = url
      this.editForm.introduceimage3 = url
    },
    clickreturn () {
      this.activeName = 'first'
      this.displaythree = false
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiRuiShiLiGouWuProductsGetList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiRuiShiLiGouWuProductsGetNum()
      this.apiRuiShiLiGouWuProductsGetList()
    },
    clickadd () {
      this.apiRuiShiLiGouWuProductsAdd()
    },
    clickEdit (row) {
      this.editForm.id = row.Id
      this.editForm.name = row.Name
      this.editForm.price = row.Price
      this.editForm.iconimage = row.Iconimage
      this.editForm.introduceimage1 = row.Introduceimage1
      this.editForm.introduceimage2 = row.Introduceimage2
      this.editForm.introduceimage3 = row.Introduceimage3

      this.displaythree = true
      this.activeName = 'three'
    },
    postEdit () {
      this.apiRuiShiLiGouWuProductsEdit()
    },
    //
    clickShangJia (row) {
      this.$confirm('是否上架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiRuiShiLiGouWuProductsShangXiaJia(row.Id, '1')
      })
    },
    clickXiaJia (row) {
      this.$confirm('是否下架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiRuiShiLiGouWuProductsShangXiaJia(row.Id, '0')
      })
    },
    apiRuiShiLiGouWuProductsGetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuProductsGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuProductsGetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuProductsGetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuProductsAdd: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        price: that.addForm.price,
        iconimage: that.addForm.iconimage,
        introduceimage1: that.addForm.introduceimage1,
        introduceimage2: that.addForm.introduceimage2,
        introduceimage3: that.addForm.introduceimage3
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuProductsAdd, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiRuiShiLiGouWuProductsGetNum()
            that.apiRuiShiLiGouWuProductsGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuProductsEdit: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        name: that.editForm.name,
        price: that.editForm.price,
        iconimage: that.editForm.iconimage,
        introduceimage1: that.editForm.introduceimage1,
        introduceimage2: that.editForm.introduceimage2,
        introduceimage3: that.editForm.introduceimage3
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuProductsEdit, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.displaythree = false
            that.apiRuiShiLiGouWuProductsGetNum()
            that.apiRuiShiLiGouWuProductsGetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiShiLiGouWuProductsShangXiaJia: function (id, shelves) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        shelves: shelves
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiShiLiGouWuProductsShangXiaJia, Qs.stringify(data))
        .then(function (response) {
          that.apiRuiShiLiGouWuProductsGetNum()
          that.apiRuiShiLiGouWuProductsGetList()
          Vue.prototype.FunCheckApiCode(response.data)
          console.log(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
